import { Body, Controller, Post } from '@nestjs/common';
import { ApiBody } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { CommonResponseModel } from '@project-management-system/shared-models';
import { CreateJobworkDto } from './dto/job-work-creation-dto';
import { JobworkCreationService } from './job-work-creation-service';
import { VendorReq } from './dto/vendor-req';
import { VendorStatusUpdateReq } from './dto/vendor-status-update-req';
import { JobworkIdReq } from './dto/job-work-id.req';

@Controller('job-work-creation')
export class JobworkCreationController {
    constructor(
        private jobworkCreationService: JobworkCreationService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createJobwork')
    @ApiBody({ type: CreateJobworkDto })
    async createJobwork(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.createJobwork(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }


    @Post('/updateJobworkCreation')
    @ApiBody({ type: CreateJobworkDto })
    async updateJobworkCreation(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.updateJobworkCreation(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllJobworkCreationData')
    async getAllJobworkCreationData(): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.getAllJobworkCreationData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getVendorPrice')
    @ApiBody({ type: VendorReq })
    async getVendorPrice(@Body() req: any): Promise<CommonResponseModel> {
        console.log(req, '---controller')
        try {
            return await this.jobworkCreationService.getVendorPrice(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllVendorsData')
    async getAllVendorsData(): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.getAllVendorsData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateAcceptOrRejectStatus')
    @ApiBody({ type: VendorStatusUpdateReq })
    async updateAcceptOrRejectStatus(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.updateAcceptOrRejectStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getJobworkFormDataById')
    @ApiBody({ type: JobworkIdReq })
    async getJobworkFormDataById(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.jobworkCreationService.getJobworkFormDataById(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}
